import Box from 'components/shared/Box'
import Input from 'components/shared/Input'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'

interface VerifyCardNumberProps {
    handleCardNumberChange: (number: string) => void
}

const VerifyCardNumber = ({
    handleCardNumberChange,
}: VerifyCardNumberProps) => {
    const { formatMessage } = useIntl()
    const { getError } = useErrorMessages()

    const isError = !!getError('cardNumber')

    return (
        <Section>
            <Box direction="row" mb={[24, 40]}>
                <Text variant="heading2" color="grayscale_900">
                    <FormattedMessage
                        id="annual.renew.verification_header"
                        defaultMessage="Podaj numer karty"
                    />
                </Text>
            </Box>
            <Input
                id="cardNumber"
                errorMessage={formatMessage({
                    defaultMessage: 'Nieprawidłowy numer karty.',
                    id: 'annual.renew.verification_error',
                })}
                onChange={handleCardNumberChange}
                isError={isError}
                label={formatMessage({
                    defaultMessage: 'Wpisz ostatnie 4 cyfry numeru karty:',
                    id: 'annual.renew.verification_label',
                })}
                type="text"
                maxWidth={190}
                mask="####"
                maskPlaceholder={'_'}
                testId="renew-field-card-number"
            />
            {!isError && (
                <Text
                    variant="bodyExtraSmall"
                    color="grayscale_800"
                    hasTransition
                >
                    <FormattedMessage
                        id="annual.renew.verification_tip"
                        defaultMessage="Numer znajdziesz na swojej karcie Unlimited."
                    />
                </Text>
            )}
        </Section>
    )
}

export default VerifyCardNumber
